import { render, staticRenderFns } from "./MA.vue?vue&type=template&id=32ba7f30&"
import script from "./MA.vue?vue&type=script&lang=js&"
export * from "./MA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports